import { useMemo, useState } from "react";
import ArticleCard from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";

export default function CategoryExplorer() {
  const [active, setActive] = useState("all");

  const tabs = useMemo(
    () => [{ slug: "all", name: "全部爆料" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))],
    [],
  );

  const list = useMemo(() => {
    if (active === "all") return articles.slice(0, 6);
    return articles.filter((a) => a.category === active);
  }, [active]);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="CATEGORIES"
          title="按栏目找瓜，效率更高"
          desc="明星塌房、艺人黑历史、圈内内幕、恋情风云与综艺瓜田，五大栏目持续更新。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {tabs.map((t) => (
            <button
              key={t.slug}
              type="button"
              onClick={() => setActive(t.slug)}
              className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors cursor-pointer ${
                active === t.slug
                  ? "border-primary-500 bg-primary-500 font-medium text-background-50"
                  : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {t.name}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-10 rounded-lg border border-dashed border-background-300 p-8 text-center text-sm text-foreground-500">
            该栏目暂无更新，换个栏目看看吧。
          </p>
        )}
      </div>
    </section>
  );
}